import { FieldSection } from "@/pages/settings/types";

export enum FieldSectionPage {
  ADDITIONAL = "additional",
  DETAILED_VIEW = "detailed_view"
}

const FIELD_SECTION_PAGES = new Set<string>(Object.values(FieldSectionPage));

export interface ParsedFieldSectionName {
  page: FieldSectionPage;
  displayName: string;
}

/**
 * Section names carry the page they render on: `<page>.<display name>`, e.g.
 * `detailed_view.Billing`. Names without a known page prefix predate the
 * convention and belong to the Additional Info tab, shown in full.
 */
export const parseFieldSectionName = (name: string): ParsedFieldSectionName => {
  const separatorIndex = name.indexOf(".");
  const page = name.slice(0, separatorIndex);
  if (separatorIndex > 0 && FIELD_SECTION_PAGES.has(page)) {
    return {
      page: page as FieldSectionPage,
      displayName: name.slice(separatorIndex + 1)
    };
  }
  return { page: FieldSectionPage.ADDITIONAL, displayName: name };
};

/** The page's sections, renamed to their display names */
export const getPageFieldSections = (
  fieldsSections: FieldSection[],
  page: FieldSectionPage
): FieldSection[] =>
  fieldsSections.flatMap((section) => {
    const parsedName = parseFieldSectionName(section.name);
    return parsedName.page === page
      ? [{ ...section, name: parsedName.displayName }]
      : [];
  });
